import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesPrioritizedQuery } from './UpdatesPrioritized.query';

interface IUpdatesPrioritized {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesPrioritized = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesPrioritized) => {
  return (
    <UpdatesPrioritizedQuery
      data={data}
      isLoading={isLoading}
      isError={isError}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesPrioritized };
